import { HighDefinitionIcon } from './HighDefinitionIcon';

/**
 * author: Austin Andrews
 * id 8FC812E7-2B7B-412B-9114-1899203DECC4
 * name high-definition
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/high-definition.svg
 * tags
 * - Video / Movie 
 */
export const HdIcon = HighDefinitionIcon;
export default HdIcon